const PASSWORD = 'password';
const EMAIL = 'email';

export { PASSWORD, EMAIL };
